import React from 'react'

const FirstSection = () => {
    return (
        <>
            <div className='text-2xl sm:text-4xl font-bold text-center'>Affordable Health Care Carriers</div>
            <div className='space-y-4'>
                <p>At Insurance Enterprise, we are proud to work with a wide range of reputable health insurance carriers to offer our clients a variety of insurance options to choose from. Our carriers include well-known names such as Aetna, Aliera, Assurant, Cigna, and United Healthcare.</p>
                <p>We understand that finding the right insurance coverage can be a daunting task, which is why we work closely with our clients to assess their unique needs and recommend the best insurance solutions to fit their individual requirements and budget.</p>
                <p>Unlike Obamacare carriers, we provide access to a diverse range of private insurance carriers and policies. We are confident that we can help you find the right health insurance coverage to meet your needs, whether you’re looking for individual, family, or small business insurance.</p>
                <p>So, whether you’re a first-time insurance buyer or looking to switch providers, we’re here to help you find the coverage you need at a price you can afford.</p>
            </div>
        </>
    )
}

export default FirstSection